module.exports = __webpack_public_path__ + "img/safari_48x48.d0e9b2f9.png";